import { createApp } from 'vue'

import {
  Button,
  message,
  ConfigProvider,
  Form,
  Input,
  Image,
  Menu,
  Dropdown,
  Tabs,
  PageHeader,
  Descriptions,
  Anchor,
  Table,
  Alert,
  Card,
  Select,
  Pagination,
  Modal,
  Tag,
  Row,
  Col,
  DatePicker,
  Layout,
  Radio,
  List,
  Result,
  Timeline,
  Skeleton,
  TimePicker,
  Tooltip,
  Tree,
  Upload,
  Badge,
  Switch,
  Spin,
  Checkbox,
  Breadcrumb,
  Carousel,
  Divider,
  Drawer,
  Statistic,
  Collapse,
  BackTop,
  Popconfirm,
  Empty,
  AutoComplete,
  Typography
} from "ant-design-vue"

import App from './App.vue'

import titleMixin from "./utils/titleMixin"
import focusMixin from "./utils/focusMixin"
import print from "vue3-print-nb"
import ECharts from "vue-echarts"

import store from "./store"
import router from "./router"

import { GlobalCmComponent } from "codemirror-editor-vue3"
import CKEditor from "@mayasabha/ckeditor4-vue3"
import { LineChart, BarChart, PieChart, GraphChart } from "echarts/charts"
import { CanvasRenderer } from "echarts/renderers"
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  ToolboxComponent,
  GridComponent
} from "echarts/components"
import { use } from "echarts/core"

import "./styles/index.less"
import "./styles/tailwind.css"

const app = createApp(App)
app.use(store)
app.use(router)
app.use(print)
app.component("v-chart", ECharts)

app.mixin(titleMixin)
app.mixin(focusMixin)

use([
  LineChart,
  BarChart,
  PieChart,
  GraphChart,
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  ToolboxComponent,
  GridComponent
])

app.config.productionTip = false

app.use(Button)
app.use(ConfigProvider)
app.use(Form)
app.use(Input)
app.use(Image)
app.use(Menu)
app.use(Dropdown)
app.use(Tabs)
app.use(PageHeader)
app.use(Descriptions)
app.use(Anchor)
app.use(Table)
app.use(AutoComplete)
app.use(Alert)
app.use(Card)
app.use(Select)
app.use(Pagination)
app.use(Modal)
app.use(Tag)
app.use(Row)
app.use(Col)
app.use(DatePicker)
app.use(Layout)
app.use(Radio)
app.use(List)
app.use(Upload)
app.use(Result)
app.use(Timeline)
app.use(Skeleton)
app.use(TimePicker)
app.use(Tooltip)
app.use(Tree)
app.use(Badge)
app.use(Switch)
app.use(Spin)
app.use(Checkbox)
app.use(Breadcrumb)
app.use(Carousel)
app.use(Divider)
app.use(Drawer)
app.use(Statistic)
app.use(Collapse)
app.use(BackTop)
app.use(Popconfirm)
app.use(Empty)
app.use(Typography)
app.use(CKEditor)
app.use(GlobalCmComponent)

app.mount("#app");
app.config.globalProperties.$message = message;
